export default {
  'form-step-form.basic.title': 'Basic form',
  'form-step-form.basic.description':
    'Form pages are used to collect or verify information to users, and basic forms are common in scenarios where there are fewer data items.',

  'form-step-form.email.required': 'Por favor insira seu email!',
  'form-step-form.email.wrong-format': 'O email está errado!',
  'form-step-form.userName.required': 'Por favor insira nome de usuário!',
  'form-step-form.password.required': 'Por favor insira sua senha!',
  'form-step-form.password.twice': 'As senhas não estão iguais!',
  'form-step-form.strength.msg':
    'Por favor insira pelo menos 6 caracteres e não use senhas fáceis de adivinhar.',
  'form-step-form.strength.strong': 'Força: forte',
  'form-step-form.strength.medium': 'Força: média',
  'form-step-form.strength.short': 'Força: curta',
  'form-step-form.confirm-password.required': 'Por favor confirme sua senha!',
  'form-step-form.phone-number.required': 'Por favor insira seu telefone!',
  'form-step-form.phone-number.wrong-format': 'Formato de telefone errado!',
  'form-step-form.verification-code.required': 'Por favor insira seu código de verificação!',

  'form-step-form.form.get-captcha': 'Get Captcha',
  'form-step-form.captcha.second': 'sec',
  'form-step-form.email.placeholder': 'Email',
  'form-step-form.password.placeholder': 'Senha',
  'form-step-form.confirm-password.placeholder': 'Confirme a senha',
  'form-step-form.phone-number.placeholder': 'Telefone',
  'form-step-form.verification-code.placeholder': 'Código de verificação',
  'form-step-form.form.optional': ' (optional) ',
  'form-step-form.form.submit': 'Submit',
  'form-step-form.form.save': 'Save',
  'form-step-form.title.label': 'Title',
  'form-step-form.title.placeholder': 'Give the target a name',
  'form-step-form.date.label': 'Start and end date',
  'form-step-form.placeholder.start': 'Start date',
  'form-step-form.placeholder.end': 'End date',
  'form-step-form.goal.label': 'Goal description',
  'form-step-form.goal.placeholder': 'Please enter your work goals',
  'form-step-form.standard.label': 'Metrics',
  'form-step-form.standard.placeholder': 'Please enter a metric',
  'form-step-form.client.label': 'Client',
  'form-step-form.label.tooltip': 'Target service object',
  'form-step-form.client.placeholder':
    'Please describe your customer service, internal customers directly @ Name / job number',
  'form-step-form.invites.label': 'Inviting critics',
  'form-step-form.invites.placeholder':
    'Please direct @ Name / job number, you can invite up to 5 people',
  'form-step-form.weight.label': 'Weight',
  'form-step-form.weight.placeholder': 'Please enter weight',
  'form-step-form.public.label': 'Target disclosure',
  'form-step-form.label.help': 'Customers and invitees are shared by default',
  'form-step-form.radio.public': 'Public',
  'form-step-form.radio.partially-public': 'Partially public',
  'form-step-form.radio.private': 'Private',
  'form-step-form.publicUsers.placeholder': 'Open to',
  'form-step-form.option.A': 'Colleague A',
  'form-step-form.option.B': 'Colleague B',
  'form-step-form.option.C': 'Colleague C',
};
